import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { StepState } from './types';

export const initialState: StepState = {
  currentStep: 1,
};

const slice = createSlice({
  name: 'step',
  initialState,
  reducers: {
    setStep(state, action: PayloadAction<any>) {
      state.currentStep = action.payload;
    },
  },
});

export const { actions: stepActions } = slice;
export const { reducer: stepReducer } = slice;
